import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import planet from '../assets/images/illustrations/planet.svg';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
	width: 100%;
`;

const NotFound = () => (
	<StyledContainer>
		<img src={planet} width={230} alt="planet" />
		<span style={{ marginTop: '30px', textAlign: 'center' }}>
			Oops, la route recherché n&apos;existe pas.
			<br />
			<Link to="/">Retour à l&apos;acceuil</Link>
		</span>
	</StyledContainer>
);

export default NotFound;
